import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Loads catalogue (groups, categories, info) from backend.
 * Returns: { data, loading, error, reload }
 */
export function useCatalogue() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = async () => {
    setLoading(true);
    try {
      const r = await api.get("/catalogue");
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  return { data, loading, error, reload };
}
